import {
  DashboardOutlined,
  UserOutlined,
  CarOutlined,
  FileProtectOutlined,
  EnvironmentOutlined,
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  GiftOutlined,
  TeamOutlined,
  IdcardOutlined,
  BarChartOutlined,
  DollarOutlined,
  GlobalOutlined,
  SettingOutlined,
  BellOutlined,
  TrophyOutlined,
  ShareAltOutlined,
  BankOutlined,
  ScheduleOutlined,
  ShoppingOutlined,
  CloseCircleOutlined,
  RocketOutlined,
  FileTextOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import type { ResourceProps } from '@refinedev/core';

export const resources: ResourceProps[] = [
  // ============ SHARED RESOURCES (all services) ============
  {
    name: 'dashboard',
    list: '/',
    meta: {
      label: 'Bosh sahifa',
      icon: <DashboardOutlined />,
      service: 'all',
    },
  },

  // ============ TAXI SERVICE RESOURCES ============
  {
    name: 'admin/live-map',
    list: '/live-map',
    meta: {
      label: 'Jonli xarita',
      icon: <GlobalOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'users',
    meta: {
      label: 'Foydalanuvchilar',
      icon: <UserOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/users',
    list: '/users',
    show: '/users/:id',
    meta: {
      label: 'Barchasi',
      icon: <UserOutlined />,
      parent: 'users',
      service: 'taxi',
    },
  },
  {
    name: 'admin/passengers',
    list: '/passengers',
    show: '/passengers/:id',
    meta: {
      label: "Yo'lovchilar",
      icon: <IdcardOutlined />,
      parent: 'users',
      service: 'taxi',
    },
  },
  {
    name: 'admin/drivers',
    list: '/drivers',
    create: '/drivers/create',
    show: '/drivers/:id',
    meta: {
      label: 'Haydovchilar',
      icon: <CarOutlined />,
      parent: 'users',
      service: 'taxi',
    },
  },
  {
    name: 'admin/documents',
    list: '/documents',
    meta: {
      label: 'Hujjatlar',
      icon: <FileProtectOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/trips',
    list: '/trips',
    create: '/trips/create',
    show: '/trips/:tripType/:id',
    edit: '/trips/:tripType/:id/edit',
    meta: {
      label: 'Sayohatlar',
      icon: <EnvironmentOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/driver-posted-trips',
    list: '/driver-posted-trips',
    show: '/driver-posted-trips/:id',
    meta: {
      label: 'Haydovchi sayohatlari',
      icon: <SwapOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/driver-trip-bookings',
    list: '/driver-trip-bookings',
    show: '/driver-trip-bookings/:id',
    meta: {
      label: 'Sayohat buyurtmalari',
      icon: <ShoppingOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/incentives',
    list: '/incentives',
    meta: {
      label: "Rag'batlantirish",
      icon: <TrophyOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/referrals',
    list: '/referrals',
    meta: {
      label: 'Referal dasturi',
      icon: <ShareAltOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/locations',
    list: '/locations',
    meta: {
      label: 'Joylar',
      icon: <EnvironmentOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/car-brands',
    list: '/car-brands',
    meta: {
      label: 'Avtomobil markalari',
      icon: <CarOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/pricing',
    list: '/pricing',
    meta: {
      label: 'Narxlash',
      icon: <SettingOutlined />,
      service: 'taxi',
    },
  },
  // Taxi-specific shared resources
  {
    name: 'taxi/tickets',
    list: '/support',
    show: '/support/:id',
    meta: {
      label: 'Murojatlar',
      icon: <CustomerServiceOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/faqs',
    list: '/faq',
    create: '/faq/create',
    edit: '/faq/:id/edit',
    meta: {
      label: 'FAQ',
      icon: <QuestionCircleOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/cancellation-reasons',
    list: '/cancellation-reasons',
    create: '/cancellation-reasons/create',
    edit: '/cancellation-reasons/:id/edit',
    meta: {
      label: 'Bekor qilish sabablari',
      icon: <CloseCircleOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'admin/app-updates',
    list: '/app-updates',
    create: '/app-updates/create',
    edit: '/app-updates/:id/edit',
    meta: {
      label: 'Yangilanishlar',
      icon: <RocketOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/promo-codes',
    list: '/promo-codes',
    create: '/promo-codes/create',
    meta: {
      label: 'Promo kodlar',
      icon: <GiftOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/staff',
    list: '/staff',
    create: '/staff/create',
    show: '/staff/:id',
    edit: '/staff/:id/edit',
    meta: {
      label: 'Xodimlar',
      icon: <TeamOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/notifications',
    list: '/notifications',
    meta: {
      label: 'Bildirishnomalar',
      icon: <BellOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/analytics',
    list: '/analytics',
    meta: {
      label: 'Analitika',
      icon: <BarChartOutlined />,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/payments',
    list: '/payments',
    meta: {
      label: "To'lovlar",
      icon: <DollarOutlined />,
      service: 'taxi',
    },
  },

  // ============ BUS SERVICE RESOURCES ============
  {
    name: 'admin/bus/companies',
    list: '/bus/companies',
    create: '/bus/companies/create',
    show: '/bus/companies/:id',
    meta: {
      label: 'Kompaniyalar',
      icon: <BankOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/company/me',
    list: '/bus/company/me',
    meta: {
      label: "Bizning ma'lumotlar",
      icon: <BankOutlined />,
      service: 'bus',
      busCompanyOnly: true,
    },
  },
  {
    name: 'admin/bus/trips',
    list: '/bus/trips',
    create: '/bus/trips/create',
    show: '/bus/trips/:id',
    meta: {
      label: 'Reyslar',
      icon: <ScheduleOutlined />,
      service: 'bus',
    },
  },
  {
    name: 'admin/bus/bookings',
    list: '/bus/bookings',
    create: '/bus/bookings/create',
    show: '/bus/bookings/:id',
    meta: {
      label: 'Buyurtmalar',
      icon: <ShoppingOutlined />,
      service: 'bus',
    },
  },
  // Bus-specific shared resources
  {
    name: 'bus/tickets',
    list: '/bus/support',
    show: '/bus/support/:id',
    meta: {
      label: 'Murojatlar',
      icon: <CustomerServiceOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/faqs',
    list: '/bus/faq',
    create: '/bus/faq/create',
    edit: '/bus/faq/:id/edit',
    meta: {
      label: 'FAQ',
      icon: <QuestionCircleOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/promo-codes',
    list: '/bus/promo-codes',
    create: '/bus/promo-codes/create',
    meta: {
      label: 'Promo kodlar',
      icon: <GiftOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/staff',
    list: '/bus/staff',
    create: '/bus/staff/create',
    show: '/bus/staff/:id',
    edit: '/bus/staff/:id/edit',
    meta: {
      label: 'Xodimlar',
      icon: <TeamOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/reports',
    list: '/bus/reports',
    meta: {
      label: 'Hisobotlar',
      icon: <FileTextOutlined />,
      service: 'bus',
      busCompanyOnly: true,
    },
  },
  {
    name: 'bus/notifications',
    list: '/bus/notifications',
    meta: {
      label: 'Bildirishnomalar',
      icon: <BellOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/analytics',
    list: '/bus/analytics',
    meta: {
      label: 'Analitika',
      icon: <BarChartOutlined />,
      service: 'bus',
    },
  },
  {
    name: 'bus/payments',
    list: '/bus/payments',
    meta: {
      label: "To'lovlar",
      icon: <DollarOutlined />,
      service: 'bus',
    },
  },
  {
    name: 'bus/settings',
    list: '/bus/settings',
    meta: {
      label: 'Sozlamalar',
      icon: <SettingOutlined />,
      service: 'bus',
      hideForBusCompany: true,
    },
  },
];
